import React, { memo } from 'react'

import { BffInterfacesDeparture } from '@dfds-pax/booking-experience-bff'

import DepartureTierGroup from '../departure-tier/DepartureTierGroup'

interface DepartureHeaderProps {
  addDeparture: (ticket: BffInterfacesDeparture.Ticket) => void
  departureId: string
  economyProduct: string
  flexiProduct: string
  highlight?: boolean
  loading: boolean
  offerApplied: boolean
  returnLeg?: boolean
  selected?: boolean
  selectedType?: string
  selectingProduct?: string
  tickets: BffInterfacesDeparture.Ticket[]
}

const DepartureRowSelection = ({
  addDeparture,
  departureId,
  economyProduct,
  flexiProduct,
  loading,
  offerApplied,
  returnLeg,
  selected,
  selectedType,
  selectingProduct,
  tickets,
}: DepartureHeaderProps): React.ReactElement => {
  return (
    <div className="p-semantic-global-md md:p-semantic-global-lg gap-semantic-global-md md:gap-semantic-global-lg flex flex-col">
      <DepartureTierGroup
        departureId={departureId}
        economyProduct={economyProduct}
        flexiProduct={flexiProduct}
        loading={loading}
        offerApplied={offerApplied}
        onDepartureTierSelection={(ticket) => addDeparture(ticket)}
        returnLeg={returnLeg ?? false}
        selectedType={selected && selectedType ? selectedType : false}
        selectingProduct={selectingProduct}
        tickets={tickets}
      />
    </div>
  )
}

export default memo(DepartureRowSelection)
